import { Injectable } from '@angular/core';
import { KioskPermissionsInt } from '../interfaces';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KioskPermissionsService {
  private readonly _permissions: KioskPermissionsInt;

  constructor() {
    // Cargar permisos desde environment compilado
    this._permissions = environment.kioskPermissions;
    //console.log('[KioskPermissions] ✅ Configuración activa:', this._permissions);
  }

  /**
   * Obtiene todos los permisos actuales
   */
  get permissions(): KioskPermissionsInt {
    return this._permissions;
  }

  /**
   * Verifica si un permiso específico está habilitado
   * @param permission - Nombre del permiso a verificar
   * @returns true si el permiso está habilitado
   */
  hasPermission(permission: keyof KioskPermissionsInt): boolean {
    const hasIt = this._permissions[permission] === true;
    if (!hasIt) {
      //console.log(`[KioskPermissions] ⚠️ Permiso no habilitado: ${permission}`);
    }
    return hasIt;
  }

  // TODO: Futuro - merge con API remota
  // mergeWithRemotePermissions(remotePerms: Partial<KioskPermissionsInt>): void {
  //   Object.assign(this._permissions, remotePerms);
  //   console.log('[KioskPermissions] 🔄 Permisos actualizados con API remota:', this._permissions);
  // }
}
